/* eslint-disable */
(function setPublicPath() {
  // 仅开发环境需要设置
  if (process.env.NODE_ENV === 'development') {
    __webpack_public_path__ = '//localhost:3001/qw-form-editor/';
  }
}());
